import styled from "styled-components";

export default styled.div`
  height: calc(var(--vh) * 100);
`;
